import { TextInput } from '@app/components/core/input/text/TextInput'
import { forwardRef, useCallback, useState } from 'react'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import Row from '@app/components/layout/Row'

export type ReplyTextBoxProps = {
  onSumbit: (text: string) => Promise<boolean>
  onBlur?: () => void
}

export const ReplyTextBox = forwardRef<HTMLInputElement, ReplyTextBoxProps>(
  ({ onSumbit, onBlur }, ref) => {
    const [language, _] = useLanguage()
    const translations = i18n.languages[language].app.post
    const [text, setText] = useState('')
    const _submit = () => {
      void onSumbit(text).then(() => setText(''))
    }
    const onBlurCallback = useCallback(() => {
      if (text.trim() === '') {
        onBlur()
      }
    }, [text, onBlur])
    const onSubmitCallback = useCallback(() => {
      if (text.trim() === '') {
        return
      }
      void onSumbit(text).then(() => setText(''))
    }, [text, onSumbit])
    return (
      <Row>
        <TextInput
          ref={ref}
          placeholder={translations.typeYourReply}
          text={text}
          setText={setText}
          onSubmit={onSubmitCallback}
          onBlur={onBlurCallback}
          style={{
            flexGrow: 1,
          }}
        />
      </Row>
    )
  },
)

ReplyTextBox.displayName = 'ReplyTextBox'
